export default {
  header: {
    container: 'header-container',
    docsLink: 'header-docsLink',
    feedbackLink: 'header-feedbackLink',
    supportLink: 'header-supportLink',
  },
  content: {
    container: 'content-container',
  },
  mainPage: {
    sdkHero: 'MainPage-sdk-hero',
    constellationHero: 'MainPage-constellation-hero',
    descriptionContainer: 'MainPage-description',
    descriptionTitle: 'MainPage-descriptionTitle',
    descriptionText: 'MainPage-descriptionText',
  },
  triageStartPage: {
    illustrationImg: 'triageStartPage-illustration-image',
    descriptionText1: 'triageStartPage-description1',
    descriptionText2: 'triageStartPage-description2',
    nextButton: 'triageStartPage-nextButton',
    previousPageLink: 'triageStartPage-previousPageLink',
  },
  footer: {
    container: 'footer-container',
    documentationLink: 'footer-documentationLink',
    confluenceLink: 'footer-confluenceLink',
  },
  aboutYou: {
    firstName: 'first-name',
    lastName: 'last-name',
    dateOfBirth: 'date-of-birth',
    emailAddress: 'email-address',
    confirmYourEmailAddress: 'confirm-your-email-address',
    agreeToTermsAndConditions: 'agree-to-terms-and-conditions',
  },
  aboutBusiness: {
    errorSummary: 'errorSummary',
    existSortCodeError: 'existSortCodeError',
    accountNotFoundError: 'accountNotFoundError',
  },
  mayfairAccount: {
    infoList: 'infoList',
  },
};
